<template>
  <list-manage title="分类" :max="100" :prevent-back="!!selection"
    :selection="selection" :data="tags" @back="$emit('back')"
    @add="add" @update="update" @remove="remove" @select="args=>$emit('select', args)">
    <p class="t-c" style="margin-top:20px;">暂时还没有分类哦，请先添加一个吧</p>
  </list-manage>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ListManage from '@/components/ListManage'
import { isArray } from '@/utils'
export default {
  props: {
    selection: Number
  },
  computed: {
    ...mapGetters(['tags']),
  },
  components: {
    ListManage
  },
  methods: {
    ...mapActions(['addTag', 'updateTag', 'removeTag', 'removeTags']),
    add (name) {
      this.addTag(name)
    },
    update (index, name) {
      this.updateTag({ index, name })
    },
    remove (index) {
      if (isArray(index)) {
        this.removeTags(index)
      } else {
        this.removeTag(index)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Tags.vue?2c4231d0